// 부가서비스·보험 월 사용료 표시 규칙의 단일 출처.
// 프론트(신청서·시세표)와 서버(서식·문자·엑셀)가 함께 import 한다.

/** 시세표에 그대로 찍는 한 줄. 수기 문구가 있으면 손대지 않는다. */
export function addonFeeLabel(
  monthlyFee: number,
  feeNote?: string | null,
): string {
  const custom = feeNote?.trim();
  if (custom) return custom;
  const fee =
    Number.isFinite(monthlyFee) && monthlyFee > 0
      ? Math.round(monthlyFee)
      : 0;
  return `가입 시 월 ${fee.toLocaleString("ko-KR")}원`;
}

/** 이름 옆의 짧은 문구. 예) "월 5,900원" · "월 0원" · 수기 문구 원문. */
export function addonFeeChipLabel(
  monthlyFee: number,
  feeNote?: string | null,
): string {
  const custom = feeNote?.trim();
  if (custom) return custom;
  return addonFeeLabel(monthlyFee, null).replace(/^가입 시 /, "");
}

/** 편집칸의 시작값 — 아직 고친 적이 없으면 자동 문구에서 이어 고치게 한다. */
export function addonFeeLabelDraft(
  monthlyFee: number,
  feeNote?: string | null,
): string {
  return feeNote?.trim() || addonFeeLabel(monthlyFee, null);
}
